import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar/Sidebar";
import useSidebarToggle from "../../hooks/useSidebarToggle";
import Topbar from "./Topbar";
import { PiFilePlus } from "react-icons/pi";
import { BiHomeAlt, BiHelpCircle, BiCodeAlt } from "react-icons/bi";
import { MdHistory } from "react-icons/md";
import { LuActivity } from "react-icons/lu";
import type { MenuItem, SidebarTheme } from "../../types/sidebar";
import Footer from "./Footer";

interface DashboardLayoutProps {
    children?: React.ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
    const { isOpen, toggle } = useSidebarToggle();

    // MAIN MENU (typed)
    const mainMenu: MenuItem[] = [
        { name: "Dashboard", path: "/dashboard", icon: <BiHomeAlt />, end: true },
        { name: "New Scrape", path: "/new", icon: <PiFilePlus /> },
        { name: "Scrape History", path: "/history", icon: <MdHistory /> },
        { name: "Support & Help", path: "/support", icon: <BiHelpCircle /> },
        { name: "Developer API", path: "/developer", icon: <BiCodeAlt /> },
        { name: "Usage Tracker", path: "/usage", icon: <LuActivity /> },
    ];

    // Optional theme (typed)
    const sidebarTheme: SidebarTheme = {
        bgColor: "bg-white",
        borderColor: "border-gray-200",
        activeColor: "text-[#8134AF]",
        activeBg: "bg-violet-50",
    };

    return (
        <div className="flex h-screen overflow-hidden bg-white isolate">
            <Sidebar
                isOpen={isOpen}
                toggleSidebar={toggle}
                mainMenu={mainMenu}
                theme={sidebarTheme}
                expandedWidth="w-68"
                collapsedWidth="w-24"
            />

            <div className="flex-1 flex flex-col min-w-0 w-full overflow-hidden bg-white">
                <Topbar onMenuClick={toggle} />

                <div className="flex-1 overflow-x-hidden overflow-y-auto w-full flex flex-col justify-between">
                    <div className="flex-1">
                        {children || <Outlet />}
                    </div>
                    {/* Reusable Premium Footer */}
                    <Footer />
                </div>
            </div>
        </div>
    );
}

